import React, { useEffect, useState } from 'react';
import { Card, Container, FormGroup, Input, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import client from '../../utils/client';
import SimpleHeader from '../../components/Headers/SimpleHeader';

const defaultYear = new Date().getFullYear();
const nrOfYears = defaultYear - 2009 + 1;
const options = Array.from({ length: nrOfYears }, (_, i) => defaultYear - i).map((i) => (
  <option key={i} value={i}>
    {i}
  </option>
));

// const clusterMarkerPath =
//   'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
let markers = [];
let markerCluster;
let map;

const MapDefault = ({ year }) => {
  const mapRef = React.useRef(null);

  useEffect(() => {
    const { google } = window;
    map = mapRef.current;
    const lat = '56.0049213';
    const lng = '12.7280509';
    const myLatlng = new google.maps.LatLng(lat, lng);
    const mapOptions = {
      zoom: 10,
      center: myLatlng,
      scrollwheel: false,
      zoomControl: true
    };

    map = new google.maps.Map(map, mapOptions);
  }, []);

  useEffect(() => {
    (async () => {
      if (markers?.length) {
        markerCluster.removeMarkers(markers);
        markers = [];
      }

      const { data: visitors } = await client(`admin-gc/statistics/golfclub/visitors?year=${year}`);
      if (!visitors) return;

      const { google } = window;
      const bounds = new google.maps.LatLngBounds();
      visitors.forEach((v) => {
        if (!v.lat || !v.lng) return;

        // Create a marker for each place.
        const latLng = new google.maps.LatLng(v.lat, v.lng);
        const marker = new google.maps.Marker({
          position: latLng
        });
        markers.push(marker);
        bounds.extend(latLng);
      });

      markerCluster = new MarkerClusterer({ map, markers });
      map.fitBounds(bounds);
    })();
  }, [year]);

  return <div style={{ height: `1000px` }} className="map-canvas" id="map-default" ref={mapRef} />;
};

function Map() {
  const { t } = useTranslation();

  const [year, setYear] = useState(defaultYear);

  return (
    <>
      <SimpleHeader name={t('statistic-map.title', 'Besökare på karta')} />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <FormGroup>
              <Input type="select" onChange={(e) => setYear(e.target.value)}>
                {options}
              </Input>
            </FormGroup>
            <Card className="border-0">
              <MapDefault year={year} />
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default Map;
